// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.SelectInput_scroll__dUQs2::-webkit-scrollbar {
  height: 8px;
}
.SelectInput_scroll__dUQs2::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.SelectInput_scroll__dUQs2::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.SelectInput_SelectInput__Label__TS23a {
  display: flex;
  min-width: -webkit-max-content;
  min-width: max-content;
  align-items: center;
  justify-content: space-between;
}
.SelectInput_SelectInput__Label__TS23a[data-source=true] {
  position: relative;
  padding-top: 20px;
}
.SelectInput_SelectInput__Label__TS23a label {
  text-transform: capitalize;
}
.SelectInput_SelectInput__Label__TS23a label,
.SelectInput_SelectInput__Label__TS23a p {
  margin-bottom: 10px;
  font-size: 12px !important;
  line-height: 15px;
}
.SelectInput_SelectInput__Label__Error__PgiiF {
  color: var(--errorColor);
}
.SelectInput_SelectInput__rUezX .SelectInput_errorP__kNsjY {
  font-size: 10px;
}
.SelectInput_SelectInput__rUezX .SelectInput_errorP__kNsjY[data-source=true] {
  position: absolute;
  bottom: -3px;
  left: 0;
}
.SelectInput_SelectInput__Input__LHmHE {
  position: relative;
}
.SelectInput_SelectInput__Input__LHmHE .SelectInput_Icon__p-QTN {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  -webkit-margin-start: 10px;
          margin-inline-start: 10px;
}
.SelectInput_SelectInput__Input__LHmHE .SelectInput_Icon__p-QTN svg {
  width: 10px;
  height: 10px;
}
.SelectInput_SelectInput__rUezX .SelectInput_inlinePadding__NHBKN .select-input__control {
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
  background-color: var(--bgColor);
}
.SelectInput_SelectInput__rUezX .SelectInput_inlinePadding__NHBKN .select-input__control :first-child > div {
  width: -webkit-fit-content;
  width: fit-content;
}
.SelectInput_SelectInput__rUezX .SelectInput_bulkAction__LW\\+uf .select-input__single-value {
  width: 90px;
  color: var(--mainColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__control {
  overflow: hidden;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  font-size: 10px !important;
  min-height: 30px !important;
  background-color: var(--bgColor);
  border-radius: 0 !important;
  border-color: var(--borderColor) !important;
  box-shadow: none !important;
  flex-wrap: nowrap;
}
.SelectInput_SelectInput__rUezX .select-input__indicator-separator {
  display: none;
}
.SelectInput_SelectInput__rUezX .select-input__indicator {
  padding: 0 !important;
  -webkit-padding-end: 3px !important;
          padding-inline-end: 3px !important;
  color: var(--secondaryColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__indicator svg {
  transition: all 0.2s !important;
  width: 14px;
}
.SelectInput_SelectInput__rUezX .css-g1d714-ValueContainer {
  padding: 0;
}
.SelectInput_SelectInput__rUezX .select-input__value-container {
  -webkit-padding-start: 5px;
          padding-inline-start: 5px;
  color: var(--mainColor) !important;
  text-transform: capitalize;
  overflow: visible;
  overflow: initial;
}
.SelectInput_SelectInput__rUezX .select-input__control--menu-is-open .select-input__indicator svg {
  transform: rotate(-180deg);
}
.SelectInput_SelectInput__rUezX .css-b8ldur-Input {
  overflow: hidden;
}
.SelectInput_SelectInput__rUezX .css-1wa3eu0-placeholder {
  color: var(--mainColor) !important;
  white-space: nowrap;
}
.SelectInput_SelectInput__rUezX .select-input__menu {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  box-shadow: none !important;
  border: 1px solid var(--borderColor) !important;
  border-top: 0 !important;
  border-radius: 0 !important;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  -ms-border-radius: 0 !important;
  -o-border-radius: 0 !important;
  background-color: var(--bgColor) !important;
  font-size: 10px !important;
  z-index: 1400 !important;
  min-width: -webkit-max-content;
  min-width: max-content;
  text-transform: capitalize;
}
.SelectInput_SelectInput__rUezX .css-1uccc91-singleValue {
  min-width: -webkit-max-content;
  min-width: max-content;
}
.SelectInput_SelectInput__rUezX .css-1n7v3ny-option {
  background-color: var(--secondaryColor) !important;
  color: #fff;
  cursor: pointer !important;
  padding: 5px 12px !important;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}
.SelectInput_SelectInput__rUezX .css-1n7v3ny-option label {
  max-width: -webkit-max-content;
  max-width: max-content;
  white-space: nowrap;
}
.SelectInput_SelectInput__rUezX .css-9gakcf-option {
  background-color: transparent !important;
  color: var(--mainColor) !important;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 5px 12px !important;
}
.SelectInput_SelectInput__rUezX .css-9gakcf-option:hover {
  background-color: var(--secondaryColor) !important;
  color: #fff !important;
  cursor: pointer;
}
.SelectInput_SelectInput__rUezX .css-9gakcf-option label {
  max-width: -webkit-max-content;
  max-width: max-content;
  white-space: nowrap;
}
.SelectInput_SelectInput__rUezX .css-yt9ioa-option {
  padding: 5px 12px !important;
  display: flex;
  align-items: center;
}
.SelectInput_SelectInput__rUezX .css-yt9ioa-option label {
  max-width: -webkit-max-content;
  max-width: max-content;
  white-space: nowrap;
}
.SelectInput_SelectInput__rUezX .css-qc6sy-singleValue {
  max-width: 100%;
  text-align: start;
  color: var(--mainColor) !important;
  width: -webkit-max-content;
  width: max-content;
}
.SelectInput_SelectInput__rUezX .select-input__placeholder {
  text-align: start;
}
.SelectInput_SelectInput__rUezX .MuiCheckbox-root {
  padding: 0;
  -webkit-margin-end: 6px;
          margin-inline-end: 6px;
}
.SelectInput_SelectInput__rUezX .MuiSvgIcon-root {
  width: 17px;
  height: 17px;
  color: var(--borderColor);
}
.SelectInput_SelectInput__rUezX .MuiCheckbox-colorSecondary.Mui-checked {
  color: var(--mainColor) !important;
}
.SelectInput_SelectInput__rUezX .MuiCheckbox-colorSecondary.Mui-checked svg {
  fill: var(--mainColor);
}
.SelectInput_SelectInput__rUezX .css-4ljt47-MenuList {
  max-height: 220px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  overflow-y: scroll;
  min-width: -webkit-max-content;
  min-width: max-content;
  min-height: 100%;
  scrollbar-width: none;
}
.SelectInput_SelectInput__rUezX ::-webkit-scrollbar {
  display: none;
}
@-moz-document url-prefix() {
  .SelectInput_SelectInput__rUezX *,
  .SelectInput_SelectInput__rUezX html,
  .SelectInput_SelectInput__rUezX body {
    scrollbar-width: thin;
    scrollbar-color: var(--secondaryColor) #fff;
  }
}
.SelectInput_SelectInput__rUezX .select-input__control.select-input__control--menu-is-open {
  border-bottom-color: transparent !important;
}
.SelectInput_SelectInput__rUezX .select-input__control--is-focused {
  border-color: var(--secondaryColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__control--is-focused .select-input__single-value {
  color: var(--mainColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__control--is-disabled {
  background-color: var(--borderColor);
  color: rgba(79, 79, 79, 0.5) !important;
}
.SelectInput_SelectInput__rUezX .select-input-container.error .select-input__control--is-focused {
  border-color: var(--errorColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__value-container--has-value div {
  color: var(--mainColor) !important;
}
.SelectInput_SelectInput__rUezX .select-input__control.select-input__control--menu-is-open + .select-input__menu::before {
  content: "";
  position: absolute;
  top: -1px;
  height: 1px;
  width: calc(100% - 15px);
  background-color: var(--borderColor);
  left: 50%;
  transform: translateX(-50%);
}
.SelectInput_SelectInput__rUezX .SelectInput_iconInput__r9\\+Sj .select-input__value-container {
  overflow: hidden;
}

.SelectInput_Menu__Btn__1O\\+cI {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  width: 100%;
  height: 10px;
  background-color: #fff;
  border: none;
  cursor: pointer;
  margin: 0;
}

.SelectInput_Btn__ArrowDownColor__hJL-V svg path {
  stroke: rgb(229, 229, 229);
}

.SelectInput_Btn__ArrowUpColor__rRVrQ svg path {
  stroke: var(--mainColor);
}

.select-input__option {
  background-color: transparent !important;
  display: flex !important;
  align-items: center;
  color: var(--mainColor) !important;
}
.select-input__option svg {
  transition: none;
}
.select-input__option:hover, .select-input__option--is-selected:hover {
  background-color: var(--secondaryColor) !important;
  color: #fff !important;
}
.select-input__option:hover label, .select-input__option--is-selected:hover label {
  color: #fff !important;
}
.select-input__option:hover svg > path:not([stroke-width]), .select-input__option--is-selected:hover svg > path:not([stroke-width]) {
  fill: #fff !important;
}
.select-input__option:hover svg g, .select-input__option--is-selected:hover svg g {
  fill: none !important;
}
.select-input__option:hover svg g path:nth-child(2)[stroke=none], .select-input__option--is-selected:hover svg g path:nth-child(2)[stroke=none] {
  fill: #fff !important;
}
.select-input__option:hover svg *[stroke-width], .select-input__option--is-selected:hover svg *[stroke-width] {
  stroke: #fff !important;
}
.select-input__option:hover .select-input__option--is-selected, .select-input__option--is-selected:hover .select-input__option--is-selected {
  color: var(--mainColor) !important;
}
.select-input__option:hover .select-input__option--is-selected label, .select-input__option--is-selected:hover .select-input__option--is-selected label {
  color: var(--secondaryColor);
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Form/Inputs/SelectInput/SelectInput.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAlDE;EACE,aAAA;EACA,8BAAA;EAAA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAqDJ;AAnDI;EACE,kBAAA;EACA,iBAAA;AAqDN;AAnDI;EACE,0BAAA;AAqDN;AAlDI;;EAGE,mBAAA;EDwFF,0BAAA;ECtFE,iBAAA;AAmDN;AAjDI;EACE,wBAAA;AAmDN;AAhDE;EACE,eAAA;AAkDJ;AAjDI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;AAmDN;AAhDE;EAEE,kBAAA;AAiDJ;AAhDI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;UAAA,yBAAA;AAkDN;AAjDM;EACE,WAAA;EACA,YAAA;AAmDR;AA7CM;EACE,2BAAA;UAAA,0BAAA;EACA,gCAAA;AA+CR;AA7CU;EACE,0BAAA;EAAA,kBAAA;AA+CZ;AAvCM;EACE,WAAA;EACA,kCAAA;AAyCR;AApCI;EACE,gBAAA;EACA,2BAAA;UAAA,0BAAA;ED+BF,0BAAA;EC7BE,2BAAA;EACA,gCAAA;EACA,2BAAA;EACA,2CAAA;EACA,2BAAA;EACA,iBAAA;AAsCN;AAlCI;EACE,aAAA;AAoCN;AAlCI;EAKE,qBAAA;EACA,mCAAA;UAAA,kCAAA;EACA,uCAAA;AAgCN;AAtCM;EACE,+BAAA;EACA,WAAA;AAwCR;AAlCI;EACE,UAAA;AAoCN;AAjCI;EACE,0BAAA;UAAA,yBAAA;EACA,kCAAA;EACA,0BAAA;EACA,iBAAA;EAAA,iBAAA;AAmCN;AAhCI;EACE,0BAAA;AAkCN;AA/BI;EACE,gBAAA;AAiCN;AA9BI;EACE,kCAAA;EACA,mBAAA;AAgCN;AA7BI;EACE,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,+CAAA;EACA,wBAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,2CAAA;ED3BF,0BAAA;EC6BE,wBAAA;EACA,8BAAA;EAAA,sBAAA;EACA,0BAAA;AA+BN;AA7BI;EACE,8BAAA;EAAA,sBAAA;AA+BN;AA7BI;EACE,kDAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA+BN;AA9BM;EACE,8BAAA;EAAA,sBAAA;EACA,mBAAA;AAgCR;AA7BI;EACE,wCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EAOA,4BAAA;AAyBN;AA/BM;EACE,kDAAA;EACA,sBAAA;EACA,eAAA;AAiCR;AA7BM;EACE,8BAAA;EAAA,sBAAA;EACA,mBAAA;AA+BR;AA5BI;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;AA8BN;AA7BM;EACE,8BAAA;EAAA,sBAAA;EACA,mBAAA;AA+BR;AA5BI;EACE,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,0BAAA;EAAA,kBAAA;AA8BN;AApBI;EACE,iBAAA;AAsBN;AAnBI;EACE,UAAA;EACA,uBAAA;UAAA,sBAAA;AAqBN;AAnBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AAqBN;AAlBI;EACE,kCAAA;AAoBN;AAjBI;EACE,sBAAA;AAmBN;AAhBI;EACE,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;EACA,8BAAA;EAAA,sBAAA;EACA,gBAAA;EACA,qBAAA;AAkBN;AAhBI;EACE,aAAA;AAkBN;AAdI;EACE;;;IAGE,qBAAA;IACA,2CAAA;EAgBN;AACF;AAbI;EACE,2CAAA;AAeN;AAZI;EACE,8CAAA;AAcN;AAbM;EACE,kCAAA;AAeR;AAZI;EACE,oCAAA;EACF,uCAAA;AAcJ;AAZI;EACE,0CAAA;AAcN;AAXM;EACE,kCAAA;AAaR;AAVI;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,oCAAA;EACA,SAAA;EACA,2BAAA;AAWN;AANM;EACE,gBAAA;AAQR;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AAKF;;AADI;EACE,0BAAA;AAIN;;AAEI;EACE,wBAAA;AACN;;AAKE;EACE,wCAAA;EACA,wBAAA;EACA,mBAAA;EACA,kCAAA;AAFJ;AAGI;EACE,gBAAA;AADN;AAIE;EAEE,kDAAA;EACA,sBAAA;AAFJ;AAII;EACE,sBAAA;AADN;AAII;EACE,qBAAA;AADN;AAGI;EACE,qBAAA;AAAN;AACM;EACE,qBAAA;AAER;AACI;EACE,uBAAA;AAEN;AACE;EACE,kCAAA;AAEJ;AAAE;EACE,4BAAA;AAGJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.SelectInput {\n  &__Label {\n    display: flex;\n    min-width: max-content;\n    align-items: center;\n    justify-content: space-between;\n\n    &[data-source='true'] {\n      position: relative;\n      padding-top: 20px;\n    }\n    label {\n      text-transform: capitalize;\n    }\n\n    label,\n    p {\n      // min-width: max-content;\n      margin-bottom: 10px;\n      @include fontSize(12);\n      line-height: 15px;\n    }\n    &__Error {\n      color: var(--errorColor);\n    }\n  }\n  .errorP {\n    font-size: 10px;\n    &[data-source='true'] {\n      position: absolute;\n      bottom: -3px;\n      left: 0;\n    }\n  }\n  &__Input {\n    // min-width: max-content;\n    position: relative;\n    .Icon {\n      position: absolute;\n      z-index: 1;\n      top: 50%;\n      transform: translateY(-50%);\n      margin-inline-start: 10px;\n      svg {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n  .inlinePadding {\n    :global {\n      .select-input__control {\n        padding-inline-start: 25px;\n        background-color: var(--bgColor);\n        :first-child {\n          > div {\n            width: fit-content;\n          }\n        }\n      }\n    }\n  }\n  .bulkAction {\n    :global {\n      .select-input__single-value {\n        width: 90px;\n        color: var(--mainColor) !important;\n      }\n    }\n  }\n  :global {\n    .select-input__control {\n      overflow: hidden;\n      padding-inline-start: 10px;\n      @include fontSize(10);\n      min-height: 30px !important;\n      background-color: var(--bgColor);\n      border-radius: 0 !important;\n      border-color: var(--borderColor) !important;\n      box-shadow: none !important;\n      flex-wrap: nowrap;\n      // backface-visibility: hidden;\n      // -webkit-backface-visibility: hidden;\n    }\n    .select-input__indicator-separator {\n      display: none;\n    }\n    .select-input__indicator {\n      & svg {\n        transition: all 0.2s !important;\n        width: 14px;\n      }\n      padding: 0 !important;\n      padding-inline-end: 3px !important;\n      color: var(--secondaryColor) !important;\n    }\n    .css-g1d714-ValueContainer {\n      padding: 0;\n    }\n\n    .select-input__value-container {\n      padding-inline-start: 5px;\n      color: var(--mainColor) !important;\n      text-transform: capitalize;\n      overflow: initial;\n    }\n\n    .select-input__control--menu-is-open .select-input__indicator svg {\n      transform: rotate(-180deg);\n    }\n\n    .css-b8ldur-Input {\n      overflow: hidden;\n    }\n\n    .css-1wa3eu0-placeholder {\n      color: var(--mainColor) !important;\n      white-space: nowrap;\n    }\n\n    .select-input__menu {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      box-shadow: none !important;\n      border: 1px solid var(--borderColor) !important;\n      border-top: 0 !important;\n      border-radius: 0 !important;\n      -webkit-border-radius: 0 !important;\n      -moz-border-radius: 0 !important;\n      -ms-border-radius: 0 !important;\n      -o-border-radius: 0 !important;\n      background-color: var(--bgColor) !important;\n      @include fontSize(10);\n      z-index: 1400 !important;\n      min-width: max-content;\n      text-transform: capitalize;\n    }\n    .css-1uccc91-singleValue {\n      min-width: max-content;\n    }\n    .css-1n7v3ny-option {\n      background-color: var(--secondaryColor) !important;\n      color: #fff;\n      cursor: pointer !important;\n      padding: 5px 12px !important;\n      display: flex;\n      align-items: center;\n      flex-wrap: nowrap;\n      label {\n        max-width: max-content;\n        white-space: nowrap;\n      }\n    }\n    .css-9gakcf-option {\n      background-color: transparent !important;\n      color: var(--mainColor) !important;\n      display: flex;\n      align-items: center;\n      flex-wrap: nowrap;\n      &:hover {\n        background-color: var(--secondaryColor) !important;\n        color: #fff !important;\n        cursor: pointer;\n      }\n\n      padding: 5px 12px !important;\n      label {\n        max-width: max-content;\n        white-space: nowrap;\n      }\n    }\n    .css-yt9ioa-option {\n      padding: 5px 12px !important;\n      display: flex;\n      align-items: center;\n      label {\n        max-width: max-content;\n        white-space: nowrap;\n      }\n    }\n    .css-qc6sy-singleValue {\n      max-width: 100%;\n      text-align: start;\n      color: var(--mainColor) !important;\n      width: max-content;\n      // #{$ltr} & {\n      //   width: 70px;\n      // }\n      // #{$rtl} & {\n      //   width: 60px;\n      //   // margin-right: 22px;\n      // }\n    }\n\n    .select-input__placeholder {\n      text-align: start;\n    }\n\n    .MuiCheckbox-root {\n      padding: 0;\n      margin-inline-end: 6px;\n    }\n    .MuiSvgIcon-root {\n      width: 17px;\n      height: 17px;\n      color: var(--borderColor);\n    }\n\n    .MuiCheckbox-colorSecondary.Mui-checked {\n      color: var(--mainColor) !important;\n    }\n\n    .MuiCheckbox-colorSecondary.Mui-checked svg {\n      fill: var(--mainColor);\n    }\n\n    .css-4ljt47-MenuList {\n      max-height: 220px;\n      padding-top: 0 !important;\n      padding-bottom: 0 !important;\n      overflow-y: scroll;\n      min-width: max-content;\n      min-height: 100%;\n      scrollbar-width: none; // firefox\n    }\n    ::-webkit-scrollbar {\n      display: none;\n    }\n\n    // custom scrollbar for firefox\n    @-moz-document url-prefix() {\n      *,\n      html,\n      body {\n        scrollbar-width: thin;\n        scrollbar-color: var(--secondaryColor) #fff;\n      }\n    }\n\n    .select-input__control.select-input__control--menu-is-open {\n      border-bottom-color: transparent !important;\n    }\n\n    .select-input__control--is-focused {\n      border-color: var(--secondaryColor) !important;\n      .select-input__single-value {\n        color: var(--mainColor) !important;\n      }\n    }\n    .select-input__control--is-disabled{\n      background-color: var(--borderColor);\n    color: rgba(79, 79, 79, 0.5) !important;\n    }\n    .select-input-container.error .select-input__control--is-focused {\n      border-color: var(--errorColor) !important;\n    }\n    .select-input__value-container--has-value {\n      div {\n        color: var(--mainColor) !important;\n      }\n    }\n    .select-input__control.select-input__control--menu-is-open\n      + .select-input__menu::before {\n      content: '';\n      position: absolute;\n      top: -1px;\n      height: 1px;\n      width: calc(100% - 15px);\n      background-color: var(--borderColor);\n      left: 50%;\n      transform: translateX(-50%);\n    }\n  }\n  .iconInput {\n    :global {\n      .select-input__value-container {\n        overflow: hidden;\n        // width: 62px;\n      }\n    }\n  }\n}\n.Menu__Btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  width: 100%;\n  height: 10px;\n  background-color: #fff;\n  border: none;\n  cursor: pointer;\n  margin: 0;\n}\n.Btn__ArrowDownColor {\n  svg {\n    path {\n      stroke: rgb(229, 229, 229);\n    }\n  }\n}\n.Btn__ArrowUpColor {\n  svg {\n    path {\n      stroke: var(--mainColor);\n    }\n  }\n}\n\n:global {\n  .select-input__option {\n    background-color: transparent !important;\n    display: flex !important;\n    align-items: center;\n    color: var(--mainColor) !important;\n    svg {\n      transition: none;\n    }\n  }\n  .select-input__option:hover,\n  .select-input__option--is-selected:hover {\n    background-color: var(--secondaryColor) !important;\n    color: #fff !important;\n\n    label {\n      color: #fff !important;\n    }\n\n    svg > path:not([stroke-width]) {\n      fill: #fff !important;\n    }\n    svg g{\n      fill: none !important;\n      & path:nth-child(2)[stroke=\"none\"]{\n        fill: #fff !important;\n      }\n    }\n    svg *[stroke-width]{\n      stroke: #fff !important;\n  }\n\n  .select-input__option--is-selected {\n    color: var(--mainColor) !important;\n  }\n  .select-input__option--is-selected label {\n    color: var(--secondaryColor);\n  }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `SelectInput_scroll__dUQs2`,
	"SelectInput__Label": `SelectInput_SelectInput__Label__TS23a`,
	"SelectInput__Label__Error": `SelectInput_SelectInput__Label__Error__PgiiF`,
	"SelectInput": `SelectInput_SelectInput__rUezX`,
	"errorP": `SelectInput_errorP__kNsjY`,
	"SelectInput__Input": `SelectInput_SelectInput__Input__LHmHE`,
	"Icon": `SelectInput_Icon__p-QTN`,
	"inlinePadding": `SelectInput_inlinePadding__NHBKN`,
	"bulkAction": `SelectInput_bulkAction__LW+uf`,
	"iconInput": `SelectInput_iconInput__r9+Sj`,
	"Menu__Btn": `SelectInput_Menu__Btn__1O+cI`,
	"Btn__ArrowDownColor": `SelectInput_Btn__ArrowDownColor__hJL-V`,
	"Btn__ArrowUpColor": `SelectInput_Btn__ArrowUpColor__rRVrQ`
};
export default ___CSS_LOADER_EXPORT___;
